import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriberService } from 'src/app/services/app/subscriber.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { EncryptionService } from 'src/app/services/common/encryption.service';
import { LogService } from 'src/app/services/common/log.service';
import { isPlatform, Platform } from '@ionic/angular';
import { Preferences } from '@capacitor/preferences';
import { Plugin } from '@capacitor/core';
// const { GoogleAuth } = Plugins;
import { GoogleAuth } from '@codetrix-studio/capacitor-google-auth';
import { AuthService } from 'src/app/services/app/auth.service';
import { RuntimeConfigService } from 'src/app/services/app/runtime-config.service';
import { MessageService } from 'primeng/api';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AsyncPipe } from '@angular/common';

@Component({
    standalone: true,
    selector: 'app-subscriber-login',
    templateUrl: './subscriber-login.component.html',
    styleUrls: ['./subscriber-login.component.css'],
    imports: [FormsModule, ReactiveFormsModule, NgxCaptchaModule, AsyncPipe]
})
export class SubscriberLoginComponent {
  ErrorMessage: string;
  subscriberLoginGroup: FormGroup;
  googleGroup: FormGroup;
  hide = true;
  selectedValue: string;
  signUpSubscriberID = "";
  loginSubscriberID = "";

  // IsNewSubscription = 0;
  InvalidLogin = 0;
  IsPaymentCompleted = 0;

  reCaptchaVerfication = null;

  CaptchaSiteKey = environment.recaptcha.siteKey;
  public captchaIsLoaded = false;
  public captchaSuccess = false;
  public captchaIsExpired = false;
  public captchaResponse?: string;

  public theme: 'light' | 'dark' = 'light';
  public size: 'compact' | 'normal' = 'normal';
  public lang = 'en';
  public type: 'image' | 'audio';

  isElectron = false;
  isLocalNetwork = false;
  isLoading = false;

  activeSlide = 0;
  brandingSlides = [
    {
      title: 'Manufacture Smarter. Deliver Faster.',
      body: 'Plan production, manage inventory, track every process, and deliver on time, all from one powerful ERP platform.'
    },
    {
      title: 'One Platform. Complete Control.',
      body: 'Unify finance, inventory, manufacturing, and sales so every team works from the same real-time source of truth.'
    },
    {
      title: 'Operate Efficiently. Scale Confidently.',
      body: 'Automate workflows, reduce errors, and gain the visibility you need to grow without losing operational control.'
    },
    {
      title: 'Insights That Drive Decisions.',
      body: 'Monitor performance with live dashboards and reports that help you act faster and improve every business cycle.'
    }
  ];
  private slideTimer: ReturnType<typeof setInterval> | null = null;

  constructor(private subscriberService: SubscriberService,
     private router: Router, private logService: LogService, public platform: Platform,
    private authService: AuthService, public runtimeConfigService: RuntimeConfigService,
    private messageService: MessageService) {}

    async ngOnInit() {
      try {
        this.initForm();
        this.startSlideRotation();

        this.runtimeConfigService.isElectron$.subscribe((value) => this.isElectron = value);
        this.runtimeConfigService.isLocalNetwork$.subscribe((value) => this.isLocalNetwork = value);
      } catch (ex) {
        this.logService.InsertExceptionLog(ex, "Subscriber Login", "ngOnInit");
        console.log(ex);
      }
    }

  ngAfterViewInit(): void {
    if (!this.platform.is('capacitor')) {
      this.initGoogleSignInWeb();
    }
  }

  ngOnDestroy(): void {
    this.stopSlideRotation();
  }

  setActiveSlide(index: number): void {
    if (index < 0 || index >= this.brandingSlides.length) {
      return;
    }
    this.activeSlide = index;
    this.startSlideRotation();
  }

  onDotHover(index: number): void {
    this.setActiveSlide(index);
  }

  private startSlideRotation(): void {
    this.stopSlideRotation();
    this.slideTimer = setInterval(() => {
      this.activeSlide = (this.activeSlide + 1) % this.brandingSlides.length;
    }, 5000);
  }

  private stopSlideRotation(): void {
    if (this.slideTimer) {
      clearInterval(this.slideTimer);
      this.slideTimer = null;
    }
  }

  async onGoogleSignInClick() {
    if (this.platform.is('capacitor')) {
      await this.signInWithGoogle();
      return;
    }

    const googleBtn = document.querySelector('#google-button div[role="button"]') as HTMLElement | null;
    if (googleBtn) {
      googleBtn.click();
      return;
    }

    // @ts-ignore
    if (typeof google !== 'undefined' && google?.accounts?.id?.prompt) {
      // @ts-ignore
      google.accounts.id.prompt();
    }
  }

  initGoogleSignInWeb(){
    const googleButton = document.getElementById("google-button");
    if (!googleButton) {
      return;
    }

     // @ts-ignore
     google.accounts.id.initialize({
      client_id: "219534928011-mg5qkftpsbm6lf1jfk2dp158ciu6eq4c.apps.googleusercontent.com",
      callback: this.handleCredentialResponse.bind(this),
      use_fedcm_for_prompt: true,
      auto_select: false,
      cancel_on_tap_outside: true,
    });

    // @ts-ignore
    google.accounts.id.renderButton(
      googleButton,
      {
        theme: "outline",
        size: "large",
        width: 342,
        text: "signin_with",
        shape: "rectangular",
        logo_alignment: "left",
      }
    );

    // @ts-ignore
    google.accounts.id.prompt((notification: PromptMomentNotification) => {});
  }

  // Google Sign in
  async handleCredentialResponse(response: any) {
    try{
      if (response.credential) {
        const idToken = response.credential;
        const decodedToken = this.decodeIdToken(idToken);

        if (decodedToken) {
          const userEmail = decodedToken.email;

          this.googleGroup = new FormGroup({
            Email : new FormControl(userEmail)
          });

          this.subscriberService.GetPasswordFromInstituteEmail(this.googleGroup.value)
          .subscribe
          ((result) => {
            if(result != null){
              this.subscriberLoginGroup = new FormGroup({
                Username: new FormControl(userEmail),
                Password: new FormControl(result),
                rememberMe : new FormControl()
              });
              this.Userlogin(1);
            }
          },
          (err: Error) =>{
            console.log("Error in GetPasswordFromInstituteEmail API : " + err);
          });
        }
      }
    }catch(ex){
      console.log("Error in handleCredentialResponse : " + ex);
    }
  }

  decodeIdToken(idToken: string) {
    try {
      const payload = JSON.parse(atob(idToken.split('.')[1]));
      return payload;
    } catch (error) {
      console.error("Error in decodeIdToken : ", error);
      return null;
    }
  }

  initForm() {
    try{
      this.subscriberLoginGroup = new FormGroup({
        Username: new FormControl("", [Validators.required, Validators.email]),
        Password: new FormControl("", [Validators.required]),
        rememberMe : new FormControl()
      });
      this.reCaptchaVerfication = null;
    }catch(ex){
      this.logService.InsertExceptionLog(ex,"Subscriber Login","initForm");
      console.log(ex);
    }
  }

  async signInWithGoogle() {
    if (this.platform.is('capacitor')) {
      // Use Capacitor Google Auth for mobile
      try {
        await GoogleAuth.initialize({
          clientId: '219534928011-mg5qkftpsbm6lf1jfk2dp158ciu6eq4c.apps.googleusercontent.com',
          scopes: ['profile', 'email'],
          grantOfflineAccess: true
        });
        const googleUser = await GoogleAuth.signIn();
        console.log('Google User:', googleUser);
        if(googleUser) {
          let userEmail = googleUser.email;
          this.handleAndroidResponse(userEmail);
        }
      } catch (err) {
        this.logService.InsertExceptionLog(err,"Subscriber Login","signInWithGoogle");
        console.error('Error:', err);
        return null;
      }
    }
  }

  async handleAndroidResponse(response: any) {
    try{
      if (response) {
        const userEmail = response;

        this.googleGroup = new FormGroup({
          Email : new FormControl(userEmail)
        });

        this.subscriberService.GetPasswordFromInstituteEmail(this.googleGroup.value)
        .subscribe
        ((result) => {
          if(result != null){
            this.subscriberLoginGroup = new FormGroup({
              Username: new FormControl(userEmail),
              Password: new FormControl(result),
              rememberMe : new FormControl()
            });
            this.Userlogin(1);
          }
        },
        (err: Error) =>{
          console.log("Error in GetPasswordFromInstituteEmail API : " + err);
        });
      }
    }catch(ex){
      this.logService.InsertExceptionLog(ex,"Subscriber Login","signInAndroid");
      console.log("Error in handleCredentialResponse : " + ex);
    }
  }

  Userlogin(IsCookieLogin?) {
    try {
      this.InvalidLogin = 0;

      if(this.reCaptchaVerfication == null && IsCookieLogin == undefined && !this.isLocalNetwork && !this.isElectron) {
        alert("Please tick I am not a robot!");
      }
      else {
        if (this.subscriberLoginGroup.valid) {
          this.isLoading = true;
          let login = {
            Username: this.subscriberLoginGroup.value.Username,
            Password: this.subscriberLoginGroup.value.Password,
            RememberMe: this.subscriberLoginGroup.value.rememberMe
          };

          this.authService.subscriberLogin(login).subscribe(
            (result) => {
              this.isLoading = false;
              if(result.success != 0 && result.success == 1){
                this.initForm();

                if(result.subscriptionLeft <= 10){
                  if(result.subscriptionLeft <= 0){
                    this.messageService.add({
                      severity: 'warn',
                      summary: 'Subscription',
                      detail: 'Your subscription has expired. Please renew your package.',
                      life: 8000,
                    });
                  }
                  else{
                    this.messageService.add({
                      severity: 'warn',
                      summary: 'Subscription',
                      detail: 'Your subscription is expiring in ' + result.subscriptionLeft + ' days. Please renew your package.',
                      life: 8000,
                    });
                  }
                }

                this.router.navigate(['view-company'], { queryParams: { subscriberID: result.subscriberID } });
              }
              else{
                this.InvalidLogin = 1;
              }
            }, (err: Error) => {
              this.isLoading = false;
              this.InvalidLogin = 1;
              console.log(err.message);
          });
        }
      }
    } catch (ex) {
      this.isLoading = false;
      this.logService.InsertExceptionLog(ex,"Subscriber Login","Userlogin");
      console.log(ex);
    }
  }

  handleSuccess(data) {
    this.reCaptchaVerfication = data;
  }

  getErrorMessage() {
    const username = this.subscriberLoginGroup?.get('Username');
    if (!username) {
      return '';
    }
    if (username.hasError('required')) {
      return 'You must enter a value';
    }
    return username.hasError('email') ? 'Not a valid email' : '';
  }

  redirectToSignup(){
    this.router.navigate(
      ['subscriber-signup']
    );
  }

  redirectToForgotPassword(){
    this.router.navigate(
      ['subscriber-forgot-password']
    );
  }

  // ResetNewSubscription(){
  //   try{
  //     this.IsNewSubscription = 0;
  //   }catch(ex){
  //     this.logService.InsertExceptionLog(ex,"Subscriber Login","ResetNewSubscription");
  //     console.log(ex);
  //   }
  // }
}
